import React from "react";
import { Shield, Award, Network, Search } from "lucide-react";

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      bgColor: "#6052a5",
      icon: Shield,
      title: "Verified Businesses",
      description:
        "All listed businesses undergo a thorough verification process to ensure authenticity.",
    },
    {
      id: 2,
      bgColor: "#ea580c",
      icon: Award,
      title: "Trusted Partners",
      description:
        "We connect you only with reliable and trusted merchants across India.",
    },
    {
      id: 3,
      bgColor: "#4B3D9A",
      icon: Network,
      title: "Wide Network",
      description:
        "Access merchants from multiple industries and locations with ease.",
    },
    {
      id: 4,
      bgColor: "#16a34a",
      icon: Search,
      title: "Easy Search",
      description:
        "Find the right business quickly using smart category filters.",
    },
  ];

  return (
    <>
      <style>{`
        :root {
          --color-primary: #6052a5;
          --color-primary-dark: #4a3f85;
          --color-primary-light: #4B3D9A;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
        }

        .why-choose-us {
          padding: 100px 0;
          background: linear-gradient(180deg, #f9fafb 0%, #ffffff 100%);
          position: relative;
          overflow: hidden;
        }

        .why-choose-us::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 300px;
          background: radial-gradient(circle at 50% 0%, rgba(96, 82, 165, 0.05) 0%, transparent 70%);
          pointer-events: none;
        }

        .why-choose-us-container {
          margin: 0 auto;
          padding: 0 20px;
          position: relative;
          z-index: 1;
        }

        .choose-section-title {
          text-align: center;
          font-size: 3rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 20px;
          position: relative;
          display: inline-block;
          left: 50%;
          transform: translateX(-50%);
        }

        .choose-section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));
          border-radius: 2px;
        }

        .section-subtitle {
          text-align: center;
          font-size: 1.1rem;
          color: #6b7280;
          margin-bottom: 60px;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          line-height: 1.7;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
        }

        .g-4 > * {
          padding: 0 15px;
          margin-bottom: 30px;
        }

        .col-12 {
          flex: 0 0 100%;
          max-width: 100%;
        }

        .feature-card {
          background: white;
          border-radius: 20px;
          padding: 40px 30px;
          height: 100%;
          position: relative;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid transparent;
       box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          
          overflow: hidden;
        }

        .feature-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, transparent 0%, rgba(96, 82, 165, 0.03) 100%);
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
        }

        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border-color: rgba(96, 82, 165, 0.2);
        }

        .feature-card:hover::before {
          opacity: 1;
        }

        .top-border {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          transition: height 0.4s ease;
        }

        .feature-card:hover .top-border {
          height: 8px;
        }

        .icon-container {
          width: 80px;
          height: 80px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 25px;
          position: relative;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }

        .icon-container::before {
          content: '';
          position: absolute;
          top: -4px;
          left: -4px;
          right: -4px;
          bottom: -4px;
          border-radius: 22px;
          background: inherit;
          opacity: 0.2;
          filter: blur(10px);
          transition: opacity 0.4s ease;
        }

        .feature-card:hover .icon-container {
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
        }

        .feature-card:hover .icon-container::before {
          opacity: 0.4;
        }

        .choose-icon {
          width: 36px;
          height: 36px;
          color: white;
          transition: transform 0.4s ease;
        }

        .feature-card:hover .choose-icon {
          transform: scale(1.1);
        }

        .card-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 15px;
          text-align: center;
          transition: color 0.3s ease;
        }

        .feature-card:hover .card-title {
          color: var(--color-primary);
        }

        .card-description {
          font-size: 1rem;
          color: #6b7280;
          line-height: 1.7;
          text-align: center;
          margin: 0;
        }

        /* Number Badge */
        .number-badge {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgba(96, 82, 165, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--color-primary);
          transition: all 0.3s ease;
        }

        .feature-card:hover .number-badge {
          background: var(--color-primary);
          color: white;
          transform: scale(1.1);
        }

        /* Decorative Elements */
        .feature-card::after {
          content: '';
          position: absolute;
          bottom: -50px;
          right: -50px;
          width: 150px;
          height: 150px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(96, 82, 165, 0.05) 0%, transparent 70%);
          transition: all 0.6s ease;
        }

        .feature-card:hover::after {
          bottom: -30px;
          right: -30px;
          background: radial-gradient(circle, rgba(96, 82, 165, 0.1) 0%, transparent 70%);
        }

        /* Responsive Styles */
        @media (min-width: 576px) {
          .col-sm-6 {
            flex: 0 0 50%;
            max-width: 50%;
          }
        }

        @media (min-width: 992px) {
          .col-lg-3 {
            flex: 0 0 25%;
            max-width: 25%;
          }
        }

        @media (max-width: 992px) {
          .why-choose-us {
            padding: 80px 0;
          }

          .choose-section-title {
            font-size: 2.5rem;
          }

          .feature-card {
            padding: 35px 25px;
          }
        }

        @media (max-width: 768px) {
          .why-choose-us {
            padding: 60px 0;
          }

          .choose-section-title {
            font-size: 2rem;
            margin-bottom: 15px;
          }

          .section-subtitle {
            font-size: 1rem;
            margin-bottom: 40px;
          }

          .feature-card {
            padding: 30px 20px;
          }

          .icon-container {
            width: 70px;
            height: 70px;
            margin-bottom: 20px;
          }

          .choose-icon {
            width: 32px;
            height: 32px;
          }

          .card-title {
            font-size: 1.3rem;
            margin-bottom: 12px;
          }

          .card-description {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 576px) {
          .why-choose-us {
            padding: 50px 0;
          }

          .why-choose-us-container{
            padding: 0 15px;
          }

          .choose-section-title {
            font-size: 1.8rem;
          }

          .section-subtitle {
            font-size: 0.95rem;
            margin-bottom: 35px;
          }

          .feature-card {
            padding: 25px 20px;
          }

          .icon-container {
            width: 65px;
            height: 65px;
            margin-bottom: 18px;
          }

          .choose-icon {
            width: 28px;
            height: 28px;
          }

          .card-title {
            font-size: 1.2rem;
            margin-bottom: 10px;
          }

          .card-description {
            font-size: 0.9rem;
            line-height: 1.6;
          }

          .number-badge {
            width: 28px;
            height: 28px;
            font-size: 0.8rem;
            top: 15px;
            right: 15px;
          }

          .g-4 > * {
            margin-bottom: 20px;
          }
        }

        @media (max-width: 400px) {
          .choose-section-title {
            font-size: 1.6rem;
          }

          .feature-card {
            padding: 20px 15px;
          }

          .icon-container {
            width: 60px;
            height: 60px;
          }

          .card-title {
            font-size: 1.1rem;
          }

          .card-description {
            font-size: 0.85rem;
          }
        }

        /* Animation on scroll */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .feature-card {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        .feature-card:nth-child(1) {
          animation-delay: 0.1s;
        }

        .feature-card:nth-child(2) {
          animation-delay: 0.2s;
        }

        .feature-card:nth-child(3) {
          animation-delay: 0.3s;
        }

        .feature-card:nth-child(4) {
          animation-delay: 0.4s;
        }
      `}</style>

      <section className="why-choose-us">
        <div className="container why-choose-us-container">
          <h2 className="choose-section-title">Why Choose Us</h2>
          <p className="section-subtitle">
            Discover what makes us the preferred choice for connecting businesses across India
          </p>

          <div className="row g-4">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={feature.id} className="col-12 col-sm-6 col-lg-3">
                  <div className="feature-card">
                    <div
                      className="top-border"
                      style={{ backgroundColor: feature.bgColor }}
                    ></div>

                    <span className="number-badge">0{index + 1}</span>

                    <div
                      className="icon-container"
                      style={{ backgroundColor: feature.bgColor }}
                    >
                      <IconComponent className="choose-icon" />
                    </div>

                    <h4 className="card-title">{feature.title}</h4>
                    <p className="card-description">{feature.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;